<header class="header">
  <prlw-header-minimal></prlw-header-minimal>
</header>

<main class="main">
  <ng-content></ng-content>
</main>
